<template>
  <div id="service1" v-if="doctorData" :style="{ background: getService1Color()}">
    <div class="service-title">
      {{ doctorData.title }}
    </div>
    <div class="service-content" v-html="doctorData.body"></div>
  </div>
  <div id="service2" v-if="currentInserat && this.settingData.info2 === 'Inserate'" class="service2-container" :style="{ background: getService2Color()}">
    <div class="service-title">
      {{ currentInserat.title }}
    </div>
    <div class="service-content">
      <div class="slider-container">
        <transition-group name="slide" tag="div" class="slider">
          <div :key="currentInserat.id" class="slide">
            <div v-html="currentInserat.body"></div>
          </div>
        </transition-group>
      </div>
      <div class="slider-dots" v-if="this.inseratData.length > 1">
        <span v-for="(inserat, index) in inseratData" :key="inserat.id"
              :class="{ active: currentIndex === index }"
              @click="changeSlide(index)"
              :style="{ backgroundColor: currentIndex === index ? getService1Color() : '' }">

        </span>
      </div>
    </div>
  </div>
  <div id="service2-housing" :style="{ background: getService2Color()}" v-else>
    <div class="service-title">
      {{housingData.title}}
    </div>
    <div class="service-content" v-html="housingData.body">
    </div>
  </div>
  <div id="service3" :style="{ background: getService3Color()}" v-if="this.settingData.info3 === 'Winterinfo'">
    <div class="service-title">
      {{extraData[0].title}}
    </div>
    <div class="service-content" v-html="extraData[0].body">
    </div>
  </div>
  <div id="service3" :style="{ background: getService3Color()}" v-else>
    <div class="service-title">
      {{extraData[1].title}}
    </div>
    <div class="service-content" v-html="extraData[1].body">
    </div>
  </div>
</template>

<script>
export default {
  props: {
    inseratData: {
      type: Object,
      required: true,
    },
    doctorData: {
      type: Object,
      required: true,
    },
    extraData: {
      type: Object,
      required: true,
    },
    settingData: {
      type: Object,
      required: true,
    },
    housingData: {
      type: Object,
      required: true,
    }
  },
  data() {
    return {
      currentIndex: 0,
      currentInserat: null,
    };
  },
  mounted() {
    if (this.inseratData && this.inseratData.length > 0) {
      this.currentInserat = this.inseratData[0];
      setInterval(() => {
        this.currentIndex = (this.currentIndex + 1) % this.inseratData.length;
        this.currentInserat = this.inseratData[this.currentIndex];
      }, 12000); // set slider timer
    }
  },
  methods: {
    changeSlide(index) {
      this.currentIndex = index;
      this.currentInserat = this.inseratData[index];
    },
    getService1Color() {
      return this.settingData.schema === 'blau' ? '#246591' : '#4c7c74';
    },
    getService2Color() {
      return this.settingData.schema === 'blau' ? '#0799cc' : '#5ba885';
    },
    getService3Color() {
      return this.settingData.schema === 'blau' ? '#9acdf6' : '#9dcd6d';
    },
  },
}
</script>

<style>
#service1 {
  height: auto;
  display: flex;
  flex-direction: column;
  margin: 0.5%;
  margin-right: 1%;
  width: 32.5%;
  border-radius: 1vh;
  overflow: hidden;
}

#service2 {
  height: auto;
  display: flex;
  flex-direction: column;
  margin-top: 0.5%;
  margin-bottom: 0.5%;
  margin-right: 1%;
  width: 32.5%;
  border-radius: 1vh;
  overflow: hidden;
}

#service2-housing {
  height: auto;
  display: flex;
  flex-direction: column;
  margin-top: 0.5%;
  margin-bottom: 0.5%;
  margin-right: 1%;
  width: 32.5%;
  border-radius: 1vh;
  overflow: hidden;
}

#service3 {
  height: auto;
  display: flex;
  flex-direction: column;
  margin-right: 0.5%;
  margin-top: 0.5%;
  margin-bottom: 0.5%;
  width: 32.5%;
  border-radius: 1vh;
  overflow: hidden;
}

.service-title {
  display: flex;
  flex-direction: row;
  color: #ffffff;
  align-items: center;
  align-self: center;
  padding: 1%;
  height: 10%;
  font-size: 1.4vh;
  font-weight: bold;
}


.service2-container {
  height: auto; /* Change height to auto */
  display: flex;
  flex-direction: column;
  margin-right: 1%;
  margin-top: 0.5%;
  margin-bottom: 0.5%;
  width: 32.5%;
  border-radius: 1vh;
  position: relative;
  overflow-y: hidden;

}

#service3 .service-content p, #service2-housing .service-content p {
  margin-top:1vh;
  margin-bottom:1vh;
}

#service3 .service-content strong, #service2-housing .service-content strong {
  font-size:1.2vh;
}


.slider-container {
  position: relative;
  width: 100%;
  height: 90%;
}

.slide {
  flex: 0 0 90%;
  height: 90%;
  width: 94%;
  overflow-y: hidden;
}

.slide div {
  height: 90%;
  overflow-y: hidden;
}

.service-content {
  flex-direction: row;
  color: #ffffff;
  padding-left: 3%;
  padding-right: 3%;
  font-size: 1.1vh;
  overflow: hidden;
}

.slider-dots {
  display: flex;
  justify-content: center;
  align-items: flex-end;
  position: absolute;
  bottom: 1vh;
  left: 50%;
  transform: translateX(-50%);
}

.slider-dots span {
  height: 1vh;
  width: 1vh;
  background-color: #ffffff;
  border-radius: 50%;
  margin: 0 0.5vh;
  cursor: pointer;
}



.service-content ul {
  padding-left: 1vh;
}

</style>
